import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    username,
    nickname,
    password = '',
    gender = '',
    mobile = '',
    email = '',
    province = '',
    city = '',
    county = '',
    address = '',
    avatar = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.save, {
        id,
        username,
        nickname,
        password,
        gender,
        mobile,
        email,
        province,
        city,
        county,
        address,
        avatar,
    }, options);
    if (error) return { error, status };
    return content || {};
};
